import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-gateway-working',
  templateUrl: './payment-gateway-working.component.html',
  styleUrls: ['./payment-gateway-working.component.css']
})
export class PaymentGatewayWorkingComponent {
  english:boolean=false;
  hindi:boolean=false;
  ngOnInit(): void {
    const storeVal = localStorage.getItem('selectedValue');

  
    if (storeVal == 'hindi') {

      this.english = false;
      this.hindi = true;
    }
    else{
      this.english = true;
      this.hindi = false;
    }

  }

}
